export const COMPANY_DETAILS_REQUEST = 'COMPANY_DETAILS_REQUEST';
export const COMPANY_DETAILS_REQUEST_SUCCESS = 'COMPANY_DETAILS_REQUEST_SUCCESS';
export const COMPANY_DETAILS_REQUEST_FAIL = 'COMPANY_DETAILS_REQUEST_FAIL';

export const COMPANY_DETAILS_SAVE_REQUEST = 'COMPANY_DETAILS_SAVE_REQUEST';
export const COMPANY_DETAILS_SAVE_SUCCESS = 'COMPANY_DETAILS_SAVE_SUCCESS';
export const COMPANY_DETAILS_SAVE_FAIL = 'COMPANY_DETAILS_SAVE_FAIL';